


















import Vue from 'vue';

export default Vue.extend({
  layout: 'layout-error-404',
  data: () => ({
  }),
  methods: {
    goToMainPage() {
      this.$router.push('/');
    },
  },
});
